<template>
  <div class="information-library list-light texture-light-bg-css">
    <div class="w">
      <div class="page-header">
        <Breadcrumb ref="breadcrumb" class="deep-breadcrumb" />
      </div>
      <div>
        <div class="text-center content-title">
          <span class="inline-block title-font">{{ fontTitle }}</span>
        </div>
        <div class="text-center">
          <ul
            v-if="listData && listData.length !== 0"
            class="text-center image-text-lists light-flower-bg"
          >
            <li
              v-for="list in listData.data"
              :key="list.id"
              :class="
                list.ontop && list.ontop === 1 ? 'on-top relative' : 'relative'
              "
            >
              <i class="s-flower absolute"></i>
              <div class="image-text-img">
                <img
                  v-if="list.image_url || list.thumbnail_url"
                  :src="list.image_url || list.thumbnail_url"
                />
                <span v-else class="no-img w-full h-full inline-block"
                  >暂无图片</span
                >
              </div>
              <div class="image-text-content">
                <div
                  class="image-text-content-title cursor-pointer"
                  @click="listClickFn(list)"
                >
                  {{ list.title }}
                </div>
                <div class="image-text-content-info">
                  {{
                    id === 'video'
                      ? twoHalfTextFilter(list.description_text)
                      : twoHalfTextFilter(list.description)
                  }}
                </div>
                <div class="image-text-content-time">
                  {{
                    list.published_at ? dateFilter(list.published_at, '/') : ''
                  }}
                </div>
              </div>
            </li>
          </ul>
          <div v-else class="text-center image-text-lists no-data">
            暂无数据
          </div>
          <div class="pag text-center">
            <paginate
              class="clearfix deep-page"
              v-model="listData.page"
              :page-count="listData.pageCount"
              :page-range="3"
              :margin-pages="2"
              :click-handler="clickCallback"
              :prev-text="''"
              :next-text="''"
              prev-class="page-prev"
              next-class="page-next"
              :container-class="'pagination'"
              :page-class="'page-item'"
            >
            </paginate>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dateFilter from '@/core/mixins/dateFilter'
import textFilter from '@/core/mixins/textFilter'
import Breadcrumb from '@/components/common/Breadcrumb'
import { getArticles, getVideos } from '@/core/api'
import link from '@/core/mixins/link'
export default {
  name: 'information-library',
  mixins: [dateFilter, link, textFilter],
  components: {
    Breadcrumb
  },
  data() {
    return {
      listData: {
        data: [],
        total: 0, // 总数
        page: 1, // 第几页
        pageSize: 5, //每页条数
        pageCount: 0
      },
      id: 'history' // 一进页面显示第一个'历史概况'
    }
  },
  watch: {
    '$route.fullPath'() {
      this.listData.page = 1
      this.initPageData()
    }
  },
  computed: {
    fontTitle() {
      let category = this.$route.params.category || this.$route.meta.id // 从地址栏拿栏目的ID
      let breadcrumb = this.$store.getters['CategoriesStore/breadcrumb'](
        category
      )
      return breadcrumb[breadcrumb.length - 1].title
    }
  },
  mounted: function() {
    this.initPageData()
  },
  methods: {
    initPageData() {
      this.id = this.$route.params.category // 从地址栏拿栏目的ID
      this.getListData()
    },
    // 分页切换
    clickCallback(pageNum) {
      document.body.scrollIntoView()
      this.listData.page = pageNum
      this.getListData()
    },
    // 内容点击跳转
    listClickFn(data) {
      // console.log(data) // eslint-disable-line no-console
      this.link(
        {
          type: 'info',
          link: '/info',
          category: this.id,
          id: data.id
        },
        'windowOpen'
      )
    },
    async getListData() {
      let data = {
        page: this.listData.page,
        pageSize: this.listData.pageSize
      }
      if (this.id === 'video') {
        // 获取 视频列表信息
        let res = await getVideos(this.id, data)
        if (res.status === 200) {
          this.listData.total = res.data.total
          this.listData.data = res.data.data
        }
      } else {
        let res = await getArticles(this.id, data)
        // console.log(res) // eslint-disable-line no-console
        if (res.status === 200) {
          this.listData.total = res.data.total
          this.listData.data = res.data.data
        }
      }
      this.listData.pageCount = Math.ceil(
        this.listData.total / this.listData.pageSize
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.information-library {
  min-height: 80vh;
}
</style>
